import * as types from "./types";

const initialState = {
  list: [],
  meta: {},
  creating: false,
  detail: null,
  updating: false,
  comments: [],
  commentsLoading: false,
  commenting: false,
};

const report = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_REPORTS_RESPONSE:
      return {
        ...state,
        list: Array.isArray(action.payload?.list) ? action.payload.list : [],
        meta: action.payload?.meta || {},
      };

    case types.GET_REPORT_DETAIL_REQUEST:
      return {
        ...state,
        comments: [],
      };

    case types.GET_REPORT_DETAIL_RESPONSE:
      return {
        ...state,
        detail: action.payload,
      };

    case types.CREATE_REPORT_REQUEST:
      return { ...state, creating: true };

    case types.CREATE_REPORT_RESPONSE:
      return { ...state, creating: false };

    case types.UPDATE_REPORT_REQUEST:
      return { ...state, updating: true };

    case types.UPDATE_REPORT_RESPONSE: {
      const nextDetail = action.payload ?? state.detail;
      const list = Array.isArray(state.list) ? state.list : [];
      const nextList =
        nextDetail?.id != null
          ? list.map((row) =>
              row?.id === nextDetail.id ? { ...row, ...nextDetail } : row,
            )
          : list;

      return {
        ...state,
        updating: false,
        detail: nextDetail,
        list: nextList,
      };
    }

    case types.GET_REPORT_COMMENTS_REQUEST:
      return { ...state, commentsLoading: true };

    case types.GET_REPORT_COMMENTS_RESPONSE:
      return {
        ...state,
        commentsLoading: false,
        comments: Array.isArray(action.payload) ? action.payload : [],
      };

    case types.CREATE_REPORT_COMMENT_REQUEST:
      return { ...state, commenting: true };

    case types.CREATE_REPORT_COMMENT_RESPONSE:
      return { ...state, commenting: false };

    default:
      return state;
  }
};

export default report;
